import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from './../../services/authentication.service';

@Component({
  selector: 'app-view-terms-and-policies-modal',
  templateUrl: './view-terms-and-policies-modal.page.html',
  styleUrls: ['./view-terms-and-policies-modal.page.scss'],
})
export class ViewTermsAndPoliciesModalPage implements OnInit {

  constructor(
    public modalController: ModalController,
    public authService: AuthenticationService
  ) {

  }

  ngOnInit() {
  }

  agreeAndClose(){
    this.modalController.dismiss(true);
  }

  cancelModal(){
    this.modalController.dismiss(false);
  }
}
